// extracted by mini-css-extract-plugin
export default {"descriptionContainer":"description_descriptionContainer__f6Va4"};